<div class="flex content-center justify-center h-16 bg-white">
  <div class="flex items-center justify-between w-full max-w-6xl px-4">
    <a href="/">
      <svg viewBox="0 0 152.86 92.89" style="width: 62px">
        <path
          style="fill: #014a2c"
          d="M131.05.11C100.5,4.18,87.9,54,79.1,78.39,79,73.52,55.62,28.27,64.61,25.63,53.69,26.74,42.8,24.28,29,23.07,12.46,21.61-.06,31.33,0,47.74c2.12,40.71,60.42,20.65,40.58-9.32a36.53,36.53,0,0,1-15,7.6C33.49,56.26,30.3,64,21.29,64.94c-7.73.51-14.37-5.83-14.89-17.21-.18-12.2,7.09-18.95,18.29-21,6.81-1.27,20.94.17,23.1,6.72,3.35,8.53,15.1,38.34,21,54.6.45,1.28-.13,2.46-1.18,4.89H82.09C86,72,107.2,9.78,129,10.37c5.25.19,6.17,6.88,6.31,10.74,0,.77,0-.43,0,1.3,7.59-7.84,11.95-9.31,17.52-11.16C149.9,3.6,142.6-.77,131.05.11Z"
          transform="translate(0)"
        />
      </svg>
    </a>

    <ul
      class="flex gap-6 font-header font-bold text-primary-500 text-[0.9rem] h-full items-center whitespace-nowrap"
    >
      @for (item of visibleMenuItems(); track item.url) {
        <li
          class="flex items-center hover:text-secondary-500 transition-[color] ease-in h-full"
          (mouseenter)="showSubmenu(item.submenuItems)"
          (mouseleave)="hideSubmenu()"
        >
          <a
            [href]="item.url"
            [class]="
              'block h-8 hover:border-secondary-500 border-b border-transparent -mb-3' +
              (item.label === 'Homes' ? ' text-villages-gold-500' : '')
            "
          >
            {{ item.label }}
          </a>
        </li>
      }

      <li class="cursor-default border-primary-500 border-r h-5"></li>

      <li class="text-secondary-500 text-lg">
        <a href="/homefinder/"> Search Homes </a>
      </li>

      <li class="cursor-default border-primary-500 border-r h-5"></li>

      <li>
        <a href="/?s=" class="fill-primary-500 hover:fill-secondary-500 transition-[fill] ease-in">
          <svg viewBox="0 -960 960 960" class="h-7">
            <path
              d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"
            />
          </svg>
        </a>
      </li>

      <li class="cursor-default text-base">{{ temperature() }}&deg;</li>

      <li
        class="fill-primary-500 hover:fill-secondary-500 transition-[fill] ease-in overflow-visible pointer-events-none"
      >
        <div class="relative">
          <button
            (click)="handleAuthClicked()"
            class="flex flex-row items-center gap-1 relative overflow-visible pointer-events-auto"
          >
            <svg viewBox="0 0 640 640" class="h-7">
              <path
                d="M463 448.2C440.9 409.8 399.4 384 352 384L288 384C240.6 384 199.1 409.8 177 448.2C212.2 487.4 263.2 512 320 512C376.8 512 427.8 487.3 463 448.2zM64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320zM320 336C359.8 336 392 303.8 392 264C392 224.2 359.8 192 320 192C280.2 192 248 224.2 248 264C248 303.8 280.2 336 320 336z"
              />
            </svg>
            <div class="w-20 text-start truncate">
              {{ stateService.username() ? stateService.username() : '' }}
            </div>
          </button>
          <div
            [class]="
              'absolute top-11 right-5 bg-white w-60 z-10 shadow-[1px_1px_4px_0px_rgba(0,0,0,0.3)] flex flex-col p-4 rounded transition-all duration-300 overflow-visible justify-center' +
              myVillagesDropdownClass()
            "
            (mouseleave)="toggleMyVillagesDropdown(true)"
          >
            <button
              (click)="openMyVillages()"
              class="flex justify-center items-end gap-2 mb-8 hover:text-villages-gold-500 hover:fill-villages-gold-500"
            >
              <span class="text-lg">Go To</span>
              <img
                src="auth-logo.svg"
                alt="Login header image"
                title="Login header image"
                loading="lazy"
                class="h-8 object-fill myvillages-logo-hover-state"
              />
            </button>
            <span class="text-center">
              Welcome {{ stateService.username() ? stateService.username() : 'User' }}!</span
            >
            <button (click)="logout()" class="mt-20 hover:text-villages-gold-500">Logout?</button>
            <div
              class="h-5 w-5 rotate-45 rounded absolute -top-2.5 right-17 z-10 border-t border-l border-t-slate-200 border-l-slate-100 bg-white"
            ></div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>

<app-submenu
  [menuItems]="submenuItems()"
  [class]="
    'absolute flex content-center items-center justify-center w-full bg-white z-55 overflow-hidden transition-opacity ease-in shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1)] ' +
    submenuHeight() +
    ' ' +
    submenuOpacity()
  "
  (mouseenter)="showSubmenu()"
  (mouseleave)="hideSubmenu()"
/>
